import { render, staticRenderFns } from "./tagList.vue?vue&type=template&id=14516e63&scoped=true&"
import script from "./tagList.vue?vue&type=script&lang=js&"
export * from "./tagList.vue?vue&type=script&lang=js&"
import style0 from "./tagList.vue?vue&type=style&index=0&id=14516e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14516e63",
  null
  
)

export default component.exports